// Resolves after `ms`. When an AbortSignal is passed, resolves immediately on
// abort so a caller (e.g. a long-running poll loop with a multi-minute
// Retry-After) reacts to navigation without sitting out the full wait.
export const delay = (ms: number, signal?: AbortSignal): Promise<void> =>
  new Promise((resolve) => {
    if (signal?.aborted) {
      resolve();
      return;
    }

    const onAbort = () => {
      clearTimeout(timeout);
      resolve();
    };

    const timeout = setTimeout(() => {
      signal?.removeEventListener('abort', onAbort);
      resolve();
    }, ms);

    signal?.addEventListener('abort', onAbort, { once: true });
  });
